<template>
  <div class="page1-box">
    <div class="flex just-end">
      <div class="flex" style="width: 460px">
        <div class="plan-tit">评测计划</div>

        <SelectTerm
          ref="selectTerm"
          v-model="stageList"
          class="plan-input"
          api="/api-evaluation/organize/web/groupIntraAnalysis/semesterPeriodComboVoList"
          @loaded="onStageListLoad"
          @change="termChange"
        />
        <ReportDownBtn :search-params="searchParams" />
      </div>
    </div>
    <div class="content-box-new">
      <div class="search-box">
        <div v-if="classShow" class="row flex">
          <div class="label flex-center class">班级</div>
          <div class="row-con">
            <div v-if="classList.length > 0">
              <div v-for="(v, index) in classList" :key="index" class="flex">
                <div class="class-label flex items-c">
                  <div class="check-all">
                    <el-checkbox
                      v-model="v.checkAll"
                      @change="handleCheckAllClassChange($event, index)"
                    >
                      {{ v.name }}
                    </el-checkbox>
                  </div>
                </div>
                <div class="row-con flex items-c class-check-box">
                  <el-checkbox-group v-model="v.ids" @change="idsChange(index)">
                    <el-checkbox
                      v-for="(q, qIndex) in v.classrooms"
                      :key="qIndex"
                      :label="q.id"
                    >
                      {{ q.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>

          <!-- <div v-if="classList.length > 0" class="row-con">
            <div v-for="(v, index) in classList" :key="index">
              <div class="check-all">
                <el-checkbox v-model="v.checkAll" @change="handleCheckAllClassChange($event,index)">
                  {{ v.name }}
                </el-checkbox>
              </div>
              <div class="flex">
                <el-checkbox-group v-model="v.ids" @change="idsChange(index)">
                  <el-checkbox
                    v-for="(q, qIndex) in v.classrooms"
                    :key="qIndex"
                    class="mb5"
                    :label="q.id"
                  >
                    {{ q.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div> -->
        </div>
        <div class="row flex">
          <div class="label flex-center">性别</div>
          <div class="row-con flex items-c">
            <el-checkbox-group v-model="searchParams.sexes" :min="1">
              <el-checkbox
                v-for="item in $enums.gender"
                :key="item.code"
                :label="item.code"
              >
                {{ item.description }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="row flex">
          <div class="label flex-center">年龄</div>
          <div class="row-con flex items-c">
            <el-checkbox
              v-model="checkAllAge"
              @change="handleCheckAllAgeChange"
            >
              全选
            </el-checkbox>

            <el-checkbox-group
              v-model="searchParams.ageRangeTypes"
              class="ml20"
              @change="handleAgeCheckedChange"
            >
              <el-checkbox
                v-for="item in $enums.groupAnalysisAgeType"
                :key="item.code"
                :label="item.code"
              >
                {{ item.description }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>

        <div class="row flex no-border">
          <div class="label flex-center">月龄</div>
          <div class="row-con flex items-c">
            <el-row style="width: 800px">
              <el-col :span="4">
                <el-input
                  v-model="searchParams.monthAgeFromTime"
                  size="small"
                  placeholder="请输入整数"
                  @keyup.enter.native="search()"
                />
              </el-col>
              <el-col :span="1">
                <div class="text-center age-unit">月-</div>
              </el-col>
              <el-col :span="4">
                <el-input
                  v-model="searchParams.monthAgeToTime"
                  size="small"
                  placeholder="请输入整数"
                  @keyup.enter.native="search()"
                />
              </el-col>
              <el-col :span="1">
                <div class="text-center age-unit">月</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <div class="mt20">
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </div>

      <div class="mt20">
        <div
          v-if="info.heightDistribute || info.synthEZAvgScore"
          class="chart-content clearfix"
        >
          <div
            v-if="info.heightDistribute || info.bmidistribute"
            class="panel-wrap fl mb20 mr20"
          >
            <MainTitle title="体格发育" />
            <div class="clearfix mt10">
              <BasePanel
                v-if="info.heightDistribute"
                class="item fl mr20"
                :title="info.heightDistribute.title"
                :link="_getChildLink('height')"
              >
                <div class="panel-content">
                  <Pie
                    :data-list="info.heightDistribute.details"
                    :color-list="[
                      '#F87A52',
                      '#FFA100',
                      '#6DD400',
                      '#3A91FF',
                      '#A35DFF'
                    ]"
                  />
                </div>
              </BasePanel>
              <BasePanel
                v-if="info.bmidistribute"
                class="item fl"
                :title="info.bmidistribute.title"
                :link="_getChildLink('bmi')"
              >
                <div class="panel-content">
                  <Pie
                    :data-list="info.bmidistribute.details"
                    :color-list="['#3A91FF', '#6DD400', '#F87A52', '#A35DFF']"
                  />
                </div>
              </BasePanel>
            </div>
          </div>
          <div v-if="info.synthEZAvgScore" class="panel-wrap fl mb20">
            <MainTitle title="体能发育" />
            <div class="clearfix mt10">
              <BasePanel
                class="item fl mr20"
                :title="info.synthEZAvgScore.title"
                :link="_getChildLink('avg')"
              >
                <div class="panel-content">
                  <!--                  <div class="score">-->
                  <!--                    <div class="c-666 fs12">均分</div>-->
                  <!--                    <div v-if="info.synthEZAvgScore.others" class="c-score fs40">{{ info.synthEZAvgScore.others[0] }}</div>-->
                  <!--                  </div>-->
                  <AvgScore
                    v-if="info.synthEZAvgScore.others"
                    label="均分"
                    class="fl"
                    color="#FB834D"
                    :score="info.synthEZAvgScore.others[0]"
                  />
                  <Radar
                    class="mt60"
                    :data-list="info.synthEZAvgScore.details"
                  />
                </div>
              </BasePanel>
              <BasePanel
                class="item fl"
                :title="info.synthEZDistribute.title"
                :link="_getChildLink('distribution')"
              >
                <div class="panel-content">
                  <BarDashed
                    type="占比"
                    :data-list="info.synthEZDistribute.details"
                    color="#FB834D"
                  />
                </div>
              </BasePanel>
            </div>
          </div>
        </div>
        <no-data v-else />
      </div>
    </div>
    <!-- <div v-if="pdfShow" class="report-pdf">
      <div id="pdf1">
        <Page1Pdf1 :search-params="searchParams" />
      </div>
      <div id="pdf2">
        <Page1Pdf2 :search-params="searchParams" />
      </div>
      <div id="pdf3">
        <Page1Pdf3 :search-params="searchParams" />
      </div>
      <div id="pdf4">
        <Page1Pdf4 :search-params="searchParams" />
      </div>
    </div> -->
  </div>
</template>

<script>
import {
  getClassList,
  groupIntraAnalysis
} from '@/api/teachingProtection/assessment'
import SelectTerm from '@/components/SelectTerm/index.vue'

import Pie from '../_components/charts/Pie.vue'
import Radar from '../_components/charts/Radar.vue'
import BarDashed from '../_components/charts/BarDashed.vue'
import MainTitle from '../_components/MainTitle.vue'
import BasePanel from '@/components/BasePanel/index.vue'
import AvgScore from '../_components/AvgScore.vue'
import ReportDownBtn from './_components/ReportDownBtn.vue'

import { savePdfImgs } from '@/utils/savePdf.js'

export default {
  components: {
    Pie,
    Radar,
    BarDashed,
    MainTitle,
    BasePanel,
    AvgScore,
    SelectTerm,
    ReportDownBtn
  },
  props: {
    tabPosition: {}
  },
  data() {
    return {
      searchParams: {
        sexes: [101, 102],
        classroomIds: [],
        ageRangeTypes: [],
        year: '',
        semesterType: '',
        periodType: '',
        tabPosition: '',
        monthAgeFromTime: null,
        monthAgeToTime: null
      },
      ageList: [
        {
          label: '3-4岁',
          value: 101
        },
        {
          label: '4-5岁',
          value: 102
        },
        {
          label: '5-6岁',
          value: 103
        },
        {
          label: '6-7岁',
          value: 104
        }
      ],
      classList: [],
      checkAllAge: false,
      classShow: true,
      info: {
        heightDistribute: { title: '身高分布', details: [] },
        bmidistribute: { title: 'BMI分布', details: [] },
        synthEZAvgScore: { title: '综合能力均分', details: [] },
        synthEZDistribute: { title: '综合能力分布', details: [] }
      },
      stageList: [],
      pdfShow: false,
      loading: false,
      nowPrams: {}
    }
  },
  created() {},
  mounted() {
    this.searchParams.tabPosition = this.tabPosition
  },
  methods: {
    downPdf() {
      this.loading = true
      const ele1 = document.getElementById('pdf1')
      const ele2 = document.getElementById('pdf2')
      const ele3 = document.getElementById('pdf3')
      const ele4 = document.getElementById('pdf4')
      savePdfImgs([ele1, ele2, ele3, ele4], '群体分析报告', () => {
        this.loading = false
      })
    },
    termChange(v) {
      this.searchParams.year = v[0]
      this.searchParams.semesterType = v[1]
      this.searchParams.periodType = v[2]
      this.onStageListLoad(true)
    },
    onStageListLoad(noTermChange) {
      console.info(666)
      getClassList({
        year: this.searchParams.year,
        semesterType: this.searchParams.semesterType,
        periodType: this.searchParams.periodType
      }).then((res) => {
        let params = ''
        if (localStorage.getItem('searchParams')) {
          params = JSON.parse(localStorage.getItem('searchParams'))
        }
        if (params) {
          if (params.ageRangeTypes) {
            this.searchParams.ageRangeTypes = params.ageRangeTypes
            this.handleAgeCheckedChange(this.searchParams.ageRangeTypes)
          }
          if (!noTermChange) {
            this.searchParams.year = params.year
            this.searchParams.semesterType = params.semesterType
            this.searchParams.periodType = params.periodType
            this.stageList = [
              params.year,
              params.semesterType,
              params.periodType
            ]
          }

          console.info(this.stageList)
        }
        console.info(params)
        this.classList = res.data.array.filter((v) => {
          return v.name !== '其他'
        })
        this.classList.map((v, index) => {
          v.ids = []
          if (params && params.tabPosition === 1) {
            v.classrooms.map((q) => {
              if (params.classroomIds.indexOf(q.id) !== -1) {
                v.ids.push(q.id)
              }
            })
          }
          let checkedCount = this.classList[index].ids.length
          this.classList[index].checkAll =
            checkedCount === this.classList[index].classrooms.length
        })

        this.search()
      })
    },
    getInfo() {
      groupIntraAnalysis(this.searchParams).then((res) => {
        this.$fn.setVal(this.info, res.data)
      })
    },
    _getChildLink(type) {
      return `/groupStatistics/${type}?searchParams=${encodeURIComponent(
        JSON.stringify(this.nowPrams)
      )}`
    },
    onDetailClick() {
      this.$emit('button-click')
    },
    handleCheckAllAgeChange(val) {
      const arr = []
      this.$enums.groupAnalysisAgeType.map((v) => {
        arr.push(v.code)
      })
      if (val) {
        this.searchParams.ageRangeTypes = arr
      } else {
        this.searchParams.ageRangeTypes = []
      }
    },
    handleAgeCheckedChange(val) {
      let checkedCount = val.length
      this.checkAllAge =
        checkedCount === this.$enums.groupAnalysisAgeType.length
    },
    idsChange(index) {
      this.classShow = false
      this.$nextTick(() => {
        this.classShow = true
        let checkedCount = this.classList[index].ids.length
        this.classList[index].checkAll =
          checkedCount === this.classList[index].classrooms.length
      })
    },
    handleCheckAllClassChange(val, index) {
      const arr = []
      this.classList[index].classrooms.map((v) => {
        arr.push(v.id)
      })
      if (val) {
        this.classList[index].ids = arr
      } else {
        this.classList[index].ids = []
      }
      this.classShow = false
      this.$nextTick(() => {
        this.classShow = true
      })
    },
    search() {
      const arr = []
      this.classList.map((v) => {
        v.ids.map((q) => {
          arr.push(q)
        })
      })
      this.searchParams.classroomIds = arr
      console.info(this.stageList)
      this.searchParams.year = this.stageList[0] || ''
      this.searchParams.semesterType = this.stageList[1] || ''
      this.searchParams.periodType = this.stageList[2] || ''
      this.nowPrams = this.$fn.deepClone(this.searchParams)

      this.getInfo()
      this.pdfShow = false
      this.$nextTick(() => {
        this.pdfShow = true
      })
    },
    reset() {
      this.searchParams.classroomIds = []
      this.searchParams.sexes = [101, 102]
      this.searchParams.ageRangeTypes = []
      this.searchParams.monthAgeFromTime = null
      this.searchParams.monthAgeToTime = null
      this.checkAllAge = false
      this.$refs.selectTerm.reset()
      this.classList.map((v) => {
        v.checkAll = false
        v.ids = []
      })
      this.$nextTick(() => {
        this.searchParams.year = this.stageList[0] || ''
        this.searchParams.semesterType = this.stageList[1] || ''
        this.searchParams.periodType = this.stageList[2] || ''
        this.nowPrams = this.$fn.deepClone(this.searchParams)

        this.getInfo()
        this.pdfShow = false
        this.$nextTick(() => {
          this.pdfShow = true
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.class-label {
  width: 88px;
  position: relative;
  &::after {
    position: absolute;
    content: "";
    background: #d8d8d8;
    width: 1px;
    height: 18px;
    top: 50%;
    transform: translate(0, -50%);
    right: 0;
  }
}
.page1-box {
  margin-top: -30px;
}
.plan-tit {
  width: 100px;
  line-height: 30px;
  font-size: 14px;
}
.plan-input {
  width: 400px;
}
.search-box {
  border: 1px solid #e8edf2;
  .row {
    border-bottom: 1px solid #e8edf2;
    .label {
      background: #f5f7fa;
      width: 60px;
      min-height: 36px;
    }
    .class {
      min-height: 85px !important;
    }
    .row-con {
      padding: 10px 20px;
      width: 100%;
    }
    .check-all {
      margin: 5px 0;
    }
  }
}
</style>

<style lang="scss" scoped>
.age-unit {
  line-height: 30px;
}
.panel-wrap {
  padding: 20px 30px;
  background: #f6f6f6;
  border-radius: 10px;
  // width: 800px;
}
.item {
  width: 360px;
  height: 380px;
  position: relative;
}
.panel-content {
  padding: 20px;
}
.score {
  .number {
    color: #fb834d;
    font-size: 40px;
  }
}
.c-score {
  color: #fb834d;
}
</style>
